import * as $ from 'jquery';

export class InfrastructureMap {
    constructor() {
        this.$block = $('#infrastructure-block');

        if (this.$block.length === 0) return false;

        this.$mapNav = this.$block.find('.map-nav');
        this.$map = $('#infrastructure-map');

        this.mapData = JSON.parse(this.$block.attr('data-points'));
        this.convertedMapData = {
            type: 'FeatureCollection',
            features: []
        };

        this.$gmarkersArray = [];

        this.marketLogo = {};

        this.isFirst = true;

        this.init();
    }

    init = () => {
        this.initMap()
            .then(map => this.map = map)
            .then(() => {
                this.initStartView();
               /* this.mapFilter();*/
                this.initHandlers();
            });
    };

    initHandlers = () => {
        this.$mapNav.find('button').on('click', e => {
            e.preventDefault();

            const activeLength = $(e.currentTarget).siblings('button.active').length;

            if ($(e.currentTarget).hasClass('active')) {
                if (activeLength == 6) {
                    $(e.currentTarget).siblings('button').removeClass('active');
                } else if (activeLength !== 6 && activeLength > 0) {
                    $(e.currentTarget).removeClass('active');
                } else {
                    $(e.currentTarget).siblings('button').addClass('active');
                }
            } else {
                $(e.currentTarget).toggleClass('active');
            }
            this.$mapNav.find('button.active')
            this.mapFilter();
        });

    };

    initMap() {
        return new Promise(resolve => {
            ymaps.ready(() => {
                const map = new ymaps.Map('infrastructure-map', {
                    center: [53.188773, 50.086939],
                    zoom: 16,
                    controls: []
                }, {
                    suppressMapOpenBlock: true,
                    yandexMapDisablePoiInteractivity: true
                });

                map.behaviors.disable('scrollZoom');
                map.behaviors.disable('dblClickZoom');
                map.behaviors.disable('multiTouch');


                const balloonLayout = ymaps.templateLayoutFactory.createClass(
                    `<div class="popup-huyap">г. Самара, ул. Чкалова, 100п,
                  3 этаж, офис 326 <i class="close icon-cancel"></i></div> `
                )

                this.marketLogo = new ymaps.Placemark([53.188773, 50.086939], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/svg/placemark.svg',
                    iconImageSize: [44, 47],
                    balloonLayout: balloonLayout
                });

                map.geoObjects.add(this.marketLogo);

                $(window).on('resize', function () {
                    map.container.fitToViewport();
                });

                this.$gmarkersArray = [...this.$gmarkersArray, this.marketLogo];

                $('body').on('click', '.popup-huyap .close', (e) => {
                    this.marketLogo.balloon.close();
                });

                for (let typeItem in this.mapData.types) {
                    this.mapData.types[typeItem].forEach(placemarkData => {
                        const placemarkCoords = [+placemarkData.coords.split(',')[0], +placemarkData.coords.split(',')[1]];

                        const balloonLayoutPlacemark = ymaps.templateLayoutFactory.createClass(
                            `<div class="popup-huyap main">${placemarkData.label}<i class="close icon-cancel"></i></div> `)

                        this.convertedMapData.features.push(
                            {
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: placemarkCoords
                                },
                                options: {
                                    iconLayout: 'default#image',
                                    iconImageHref: './img/svg/' + typeItem + '.svg',
                                    iconImageSize: [30, 30],
                                    balloonLayout: balloonLayoutPlacemark,
                                    dataName: typeItem
                                }
                            }
                        )
                    })
                }
                console.log(this.convertedMapData)
                window.myObjects = ymaps.geoQuery(this.convertedMapData).addToMap(map);

                $('body').on('click', '.popup-huyap .close', (e) => {
                    map.balloon.close();
                })

                resolve(map);
            })
        })
    };

    initStartView = () => {
        let data = this.mapData.types;
        let activeInfoWindow;
        for (let key in data) {
            let type = key;

            if (data[key]) {
                for (let j = 0; j < data[key].length; j++) {
                    let point = data[key][j];
                    let coords = point.coords.split(',');

                    const infowindow = ymaps.templateLayoutFactory.createClass(
                        `<div class="popup-huyap">${point.label}</div>`
                    );

                    const mainWindow = new ymaps.templateLayoutFactory.createClass(
                        `<div class="popup-huyap">ЖК Вознесенский</div>`
                    );

                    /* this.marketLogo.addListener("click", () => {
                         if (activeInfoWindow) { activeInfoWindow.close(); }
                         mainWindow.open({
                             anchor: this.marketLogo,
                             shouldFocus: false,
                         });

                         activeInfoWindow = mainWindow;
                     });*/

                    let marker = new ymaps.Placemark([+coords[0], +coords[1]], {
                        map: this.$map,
                        category: type,
                        iconLayout: 'default#image',
                        iconImageHref: './img/svg/' + type + '.svg',
                        iconImageSize: [30, 30]
                    });

                    /*marker.addListener("click", () => {
                        if (activeInfoWindow) { activeInfoWindow.close(); }
                        infowindow.open({
                            anchor: marker,
                            shouldFocus: false,
                        });

                        activeInfoWindow = infowindow;
                    });*/


                    this.$gmarkersArray = [...this.$gmarkersArray, marker];


                }
            }
        }
    };

    mapFilter = () => {
        let $categories = this.$mapNav
            .find('button.active');
        let shownObjects;
        let byCategory = new ymaps.GeoQueryResult();

        for (let i = 0; i < $categories.length; i++) {
            const categoryType = $categories[i].dataset.category;

            if (categoryType) {
                byCategory = myObjects.search('options.dataName = "' + categoryType + '"').add(byCategory);
            }
        }

        // Мы отобрали объекты по категории. Покажем на карте объекты
        shownObjects = byCategory.addToMap(this.map);
        // Объекты, которые не попали в выборку, нужно убрать с карты.
        myObjects.remove(shownObjects).removeFromMap(this.map);

        /*const catArr = [];*/

        /*categories.each((key, item) => {
            const category = $(item).attr('data-category');
            catArr.push(category)
        });*/

        /*let bounds = new google.maps.LatLngBounds();
        for (let i = 0; i < this.$gmarkersArray.length; i++) {
            let marker = this.$gmarkersArray[i];

            if (catArr.includes(marker.category) || marker.category === 'all') {
                marker.setVisible(true);
                bounds.extend(marker.getPosition());
            } else {
                marker.setVisible(false);
            }
        }*/
    };
}
